import type { Types as OData } from 'shared/odata'

import { useMemo } from 'react'
import { useAppSelector } from 'shared/hooks'

import { campaignsSelectors } from '../slice'
import { useIsArchiveMode } from './archive'

export function useRequestParams() {
	const isArchive = useIsArchiveMode()
	const $searchQuery = useAppSelector(campaignsSelectors.search),
		filterQuery = useAppSelector(campaignsSelectors.filterQuery)

	const params = useMemo<Partial<OData.AudienceParams>>(() => {
		let $filter = `(archived eq ${String(isArchive)})`

		if (filterQuery && !isArchive) {
			$filter += `and (${filterQuery})`
		}

		return {
			$filter,
			$orderby: 'created desc',
			$searchQuery
		}
	}, [filterQuery, isArchive, $searchQuery])

	return [params, Boolean($searchQuery || (filterQuery && !isArchive))] as const
}
